<template>
  <NxSelectReduced
    :value="localValue"
    :options="listOptions"
    labelText="Estado Civil:"
    id="selectEstadoCivil"
    placeholder="Selecione o estado civil"
    :multiple="false"
    @update:value="handleValueUpdate"
    :isDisabled="isDisabled"
  ></NxSelectReduced>
</template>
<script>
import { useReactiveModelMixin } from '../../mixins'

export default {
  name: 'NxSelectEstadoCivil',
  mixins: [useReactiveModelMixin('value')],
  props: {
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      listOptions: [
        { value: 'CASADO(A)', text: 'CASADO(A)' },
        { value: 'SOLTEIRO(A)', text: 'SOLTEIRO(A)' },
        { value: 'DIVORCIADO(A)', text: 'DIVORCIADO(A)' },
        { value: 'VIÚVO(A)', text: 'VIÚVO(A)' },
        { value: 'UNIÃO ESTAVEL', text: 'UNIÃO ESTAVEL' },
        {
          value: 'SEPARADO(A)/DESQUITADO(A)',
          text: 'SEPARADO(A)/DESQUITADO(A)'
        }
      ],
      selected: null
    }
  },
  methods: {
    handleValueUpdate (val) {
      this.localValue = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-selects/NxSelectEstadoCivil.vue